import { Model } from 'pinia-orm';
import { Str, Uid, Attr } from 'pinia-orm/decorators';
import type { GeneralAddress, GeneralPhone } from 'types/componentsQuasar';
// import { useStrapiApi } from 'src/composables/useStrapiApi';

export class Profile extends Model {
  static override entity = 'profiles';
  @Uid() declare id: number;
  @Str('') declare documentId: string;
  // firstname/lastname are common identity on the User now (Phase 8); profile holds
  // only cold contact data.
  @Attr([{}]) declare address: GeneralAddress[];
  @Attr([{}]) declare phone: GeneralPhone[];

  @Attr(null) declare user_id: number | null;
}
